import PropTypes from "prop-types";
import Select from "react-select";
import { setActiveLayout } from "../../helpers/product";
import { useDispatch, useSelector } from "react-redux";
import { SET_FILTER } from "../../store/types";
import { getNewFilterdProducts } from "../../store/actions/product-actions";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";


const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "30px",
    padding: "2px 4px",
    borderColor: "#dcdcdc",
    boxShadow: "0 2px 5px rgba(224, 48, 48, 0.05)",
    backgroundColor: "#fff",
    minWidth: "160px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 600,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#888"
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333"
  }),
  option: (provided, state) => ({
    ...provided,
    background: state.isFocused ? "linear-gradient(135deg, #28a745 0%, #20c997 100%)" : "#fff",
    color: state.isFocused ? "white" : "#333",
    padding: 10,
    cursor: "pointer",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#999",

  })
};

const ShopTopAction = ({
  getLayout,
  getFilterSortParams,
  productCount,
  sortedProductCount
}) => {
  const [activeLayout, setActiveLayout] = useState("grid three-column");
  const handleSortChange = (selectedOption) => {
    console.log("Sort selected:", selectedOption.value);
    getFilterSortParams("filterSort", selectedOption.value);
  };


  const dispatch = useDispatch();
  const currentFilters = useSelector((state) => state.products.filter);
  console.log(currentFilters, "currentFilters")
  const sortOrderOptions = [
    { label: "Ascending", value: "asc" },
    { label: "Descending", value: "desc" },
  ];

  const sortByOptions = [
    { label: "Name", value: "name" },
    { label: "Price", value: "price" },
    { label: "Discount %", value: "disPer" },
    { label: "RAM", value: "ram" },
    { label: "Storage", value: "storage" },
    { label: "Battery Health", value: "batteryHealth" },
  ];

  const handleSortOrderChange = (selectedOption) => {
    const sortOrder = selectedOption?.value || "";
    localStorage.setItem("sortOrder", sortOrder)
    setDefaultSortOrder(selectedOption);
    dispatch({
      type: SET_FILTER,
      payload: {
        filterType: "sortOrder",
        value: sortOrder,
      },
    });

    dispatch(
      getNewFilterdProducts({
        ...currentFilters,
        page: 1,
        limit: 15,
        sortOrder,
      })
    );
  };

  const handleSortByChange = (selectedOptions) => {
    const sortBy = selectedOptions?.value || "";
    localStorage.setItem("sortBy", sortBy)
    setDefaultSortBy(selectedOptions);
    dispatch({
      type: SET_FILTER,
      payload: {
        filterType: "sortBy",
        value: sortBy,
      },
    });

    dispatch(
      getNewFilterdProducts({
        ...currentFilters,
        page: 1,
        limit: 15,
        sortBy,
      })
    );
  };
  const location = useLocation()
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();

  const [defaultSortOrder, setDefaultSortOrder] = useState("");
  const [defaultSortBy, setDefaultSortBy] = useState(null);


  useEffect(() => {
    const sortOrderParam = query.get("sortOrder");
    const sortByParam = query.get("sortBy");

    const sortOrderOption = sortOrderOptions.find(opt => opt.value === sortOrderParam);
    const sortByOption = sortByOptions.find(opt => opt.value === sortByParam);

    if (sortOrderOption) {
      setDefaultSortOrder(sortOrderOption);
    }

    if (sortByOption) {
      setDefaultSortBy(sortByOption);
    }


  }, [location.search]); 
  return (
    <div className="shop-top-bar d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
      <div className="d-flex align-items-center gap-2 flex-grow-1 flex-wrap">
        <p className="m-0">
          Showing {sortedProductCount} of {productCount} results
        </p>

        <div className="d-flex align-items-center gap-2">
          <button
            onClick={(e) => {
              getLayout("grid two-column");
              setActiveLayout(e);
              setActiveLayout("grid two-column")
            }}
            className={`btn ${activeLayout === "grid two-column" ? "btn-primary" : "btn-light"}`}
          >
            <i className="fa fa-th-large" />
          </button>
          <button
            onClick={(e) => {
              getLayout("grid three-column");
              setActiveLayout(e);
              setActiveLayout("grid three-column")
            }}
            className={`btn ${activeLayout === "grid three-column" ? "btn-primary" : "btn-light"}`}
          >
            <i className="fa fa-th" />
          </button>
        </div>
      </div>

      <div
        className="d-flex align-items-center gap-3 flex-wrap"
        style={{ minWidth: "250px" }}
      >
        <div style={{ minWidth: "150px" }}>
          <label style={{ fontWeight: "600", fontSize: "0.9rem" }}>Sort Order</label>
          <Select
            options={sortOrderOptions}
            onChange={handleSortOrderChange}
            value={defaultSortOrder || "descending"}
            placeholder="Select order"
            isClearable
            styles={{
              ...customStyles,
              menu: (provided) => ({
                ...provided,
                zIndex: 9999, // <- ensure it's on top
              }),
            }}
          />
        </div>

        <div style={{ minWidth: "150px" }}>
          <label style={{ fontWeight: "600", fontSize: "0.9rem" }}>Sort By</label>
          <Select
            options={sortByOptions}
            onChange={handleSortByChange}
            value={defaultSortBy}
            placeholder="Select fields"
            styles={{
              ...customStyles,
              menu: (provided) => ({
                ...provided,
                zIndex: 9999, // <- ensure it's on top
              }),
            }}
          />
        </div>
      </div>
    </div>

  );
};

ShopTopAction.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number
};

export default ShopTopAction;
